import { render, staticRenderFns } from "./AsideRightMenu.vue?vue&type=template&id=2885dd21&scoped=true&"
import script from "./AsideRightMenu.vue?vue&type=script&lang=js&"
export * from "./AsideRightMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885dd21",
  null
  
)

export default component.exports